import { createHelpers } from 'vuex-map-fields';

const { getDeliveryStateField, updateDeliveryStateField } = createHelpers({
    getterType: `getDeliveryStateField`,
    mutationType: `updateDeliveryStateField`,
});


const state = {
    is_load : false,
    is_load_complete : false,
    providers : [],
    locations : [],
};

// actions
const actions = {

    LOAD_DELIVERIES({commit}) {
        commit('set_load',true);
        commit('set_load_complete',false);
        commit('set_providers', []);
        commit('set_locations', []);


        delivery_api.get('/deliveries/active').then(({data}) => {
            commit('set_load',true);
            if (data.status === "operation_success") {
                let resp = data.data;
                commit('set_providers', resp);

                resp.map(provider => {
                    if(provider.hasOwnProperty("locations_count"))  {
                        actions.LOAD_DELIVERY_PROVIDER({commit},provider.id);
                    }
                });

            }
        }).catch(({response}) => {
            this.location_loaded = false;
        });
    },


    LOAD_DELIVERY_PROVIDER({commit},provider_id) {
        delivery_api.get('/deliveries/' + provider_id + '/locations').then(({data}) => {
            if (data.status === "operation_success") {
                data.data.map(loc => {
                    commit('add_location', loc);
                });
            }

        }).catch(({response}) => {

        });
    },

};

// mutations
const mutations = {

    set_providers(state,data) {
        state.providers = data;
    },

    set_locations(state,data) {
        state.locations = data;
    },

    add_location(state,data) {
        state.locations.push(data);
    },


    set_load(state,is_load) {
        state.is_load = is_load;
    },

    set_load_complete(state,is_load) {
        state.is_load_complete = is_load;
    },
};

const getters = {

    getDeliveryProviders(state) {
        return state.providers;
    },


    getDeliveryLocations(state) {
        return state.locations;
    },


    is_load(state) {
        return state.is_load;
    },

    is_load_complete(state) {
        return state.is_load_complete;
    },

    getDeliveryStateField,

};


export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations,
}
